// §6.3 / §11.7 — the house desktop surface: a generated wallpaper (D-043) and the icon grid.
//
// The grid, its drag-to-group gesture and the context menu are `host/DesktopIcons` (D-276), shared
// with the Windows skin — §6.5 lets neither import the other, and two copies of a drag-and-drop
// surface is a divergence waiting to happen. What stays here is what is genuinely this skin's:
// the wallpaper, and the class prefix its sheet styles.
import { useWallpaperBackground } from '@/host/useWallpaper';
import { DesktopIcons } from '@/host/DesktopIcons';
import { COPY } from '@/copy';

export function DesktopSurface() {
  const wallpaper = useWallpaperBackground();

  return (
    <div className="house-desktop" data-testid="desktop-surface" style={{ background: wallpaper }}>
      <DesktopIcons prefix="house" launcherLabel={COPY.chrome.openLauncher} />
    </div>
  );
}
